import { proxy } from "@/util/proxy.mjs";
import makeStrictKeysObject from "@/util/strict-keys-object.mjs";

interface ValorantRefs {
  inGamePlacement: null;
  getBearerToken?: () => Promise<string | null>;
}

export const valorantRefs = proxy(
  makeStrictKeysObject<ValorantRefs>({
    inGamePlacement: null,
    getBearerToken: () => Promise.resolve(null),
  }),
);

export default valorantRefs;

export const valLoadingScreenRefs = { VideoAd: null };
export const valAgentSelectRefs = { VideoAd: null };
export const valBenchmarkRefs = { VideoAd: null };
export const valApiRefs = { shadowingEnabled: false };
